import styled from 'styled-components';
import theme from '../theme';

export const DashboardWrapper = styled.div`
  font-family: ${theme.typography.fontFamily};
`;

export const WelcomeSection = styled.div`
  margin-bottom: ${theme.spacing.xl};
`;

export const WelcomeTitle = styled.h1`
  font-size: ${theme.typography.h1.size};
  font-weight: ${theme.typography.h1.weight};
  color: ${theme.colors.text};
  margin: 0 0 ${theme.spacing.xs} 0;

  ${theme.media.mobile} {
    font-size: ${theme.typography.h2.size};
  }
`;

export const WelcomeSubtitle = styled.p`
  font-size: ${theme.typography.body.size};
  color: ${theme.colors.textSecondary};
  margin: 0;
  line-height: ${theme.typography.body.lineHeight};
`;

export const StreakBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: ${({ $isOnStreak }) => $isOnStreak ? 'linear-gradient(135deg, #ff9500 0%, #ff5e3a 100%)' : theme.colors.background};
  color: ${({ $isOnStreak }) => $isOnStreak ? 'white' : theme.colors.textSecondary};
  padding: 4px 12px;
  border-radius: ${theme.radii.full};
  font-size: ${theme.typography.small.size};
  font-weight: 600;
  margin-left: ${theme.spacing.sm};
`;

export const SectionTitle = styled.h2`
  font-size: ${theme.typography.h3.size};
  font-weight: ${theme.typography.h3.weight};
  color: ${theme.colors.text};
  margin: ${theme.spacing.xl} 0 ${theme.spacing.md} 0;
`;

export const TrainingGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: ${theme.spacing.lg};
  margin-bottom: ${theme.spacing.xl};

  ${theme.media.mobile} {
    grid-template-columns: 1fr;
  }
`;

export const FeedbackPanel = styled.div`
  background: ${theme.colors.surface};
  border-radius: ${theme.radii.md};
  box-shadow: ${theme.shadows.sm};
  padding: ${theme.spacing.lg};
  margin-bottom: ${theme.spacing.xl};
`;

export const FeedbackHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${theme.spacing.md};
`;

export const FeedbackTitle = styled.h3`
  font-size: ${theme.typography.h3.size};
  font-weight: ${theme.typography.h3.weight};
  color: ${theme.colors.text};
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: ${theme.colors.textMuted};
  cursor: pointer;
  padding: ${theme.spacing.xs};
  border-radius: ${theme.radii.sm};
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all ${theme.transitions.fast};

  &:hover {
    background: ${theme.colors.background};
    color: ${theme.colors.text};
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: ${theme.spacing.xxl};
  color: ${theme.colors.textMuted};
  font-size: ${theme.typography.body.size};
`;

export const AchievementsSection = styled.div`
  margin-top: ${theme.spacing.xl};
`;

export const AchievementsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.spacing.md};
`;

export const AchievementCard = styled.div`
  width: 96px;
  min-width: 72px;
  padding: ${theme.spacing.md} ${theme.spacing.sm};
  border-radius: ${theme.radii.md};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.spacing.xs};
  transition: transform ${theme.transitions.fast};
  cursor: default;
  background: ${({ $earned, $color }) => $earned
    ? `linear-gradient(135deg, ${theme.colors.surface} 0%, ${$color}08 100%)`
    : theme.colors.background};
  border: 1.5px solid ${({ $earned, $color }) => $earned ? `${$color}40` : theme.colors.borderLight};
  opacity: ${({ $earned }) => $earned ? 1 : 0.5};

  ${({ $earned }) => $earned && `
    &:hover {
      transform: translateY(-2px);
    }
  `}

  ${theme.media.mobile} {
    width: 80px;
  }
`;

export const AchievementIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: ${theme.radii.full};
  background: ${({ $color, $earned }) => $earned ? $color : theme.colors.border};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: white;
  box-shadow: ${({ $color, $earned }) => $earned ? `0 2px 8px ${$color}30` : 'none'};
`;

export const AchievementName = styled.div`
  font-size: 9px;
  font-weight: 700;
  color: ${({ $color, $earned }) => $earned ? $color : theme.colors.textMuted};
  text-transform: uppercase;
  letter-spacing: 0.3px;
  line-height: 1.2;
`;

export const AchievementDesc = styled.div`
  font-size: 8px;
  color: ${theme.colors.textMuted};
  line-height: 1.2;
`;

export const ShowMoreButton = styled.button`
  background: none;
  border: none;
  color: ${theme.colors.primary};
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.small.size};
  font-weight: 600;
  cursor: pointer;
  padding: ${theme.spacing.sm} 0;
  transition: color ${theme.transitions.fast};

  &:hover {
    color: ${theme.colors.primaryDark};
  }
`;
